import { type BaseSuggestionConfig,BaseSuggestionPlugin } from '@alpod-ai-writer/plate-plugins/suggestion';
import {
    type ExtendConfig,
    isSlateEditor,
    isSlateElement,
    isSlateString,
    type Path,
} from '@udecode/plate';
import { toTPlatePlugin } from '@udecode/plate/react';

import { SuggestionLeaf } from '../components/elements/suggestionLeaf.component';
import { SuggestionBelowNodes } from '../components/elements/suggestionLineBreak.component';

export type SuggestionConfig = ExtendConfig<
  BaseSuggestionConfig,
  {
    activeId: string | null;
    currentUserId: string;
    hoverId: string | null;
    uniquePathMap: Map<string, Path>;
  }
>;

export const suggestionPlugin = toTPlatePlugin<SuggestionConfig>(
    BaseSuggestionPlugin,
    {
        handlers: {
            // unset active suggestion when clicking outside of suggestion
            onClick: ({ api, event, setOption, type }) => {
                let leaf = event.target as HTMLElement;
                let isSet = false;

                const unsetActiveSuggestion = () => {
                    setOption('activeId', null);
                    isSet = true;
                };

                if (!isSlateString(leaf)) unsetActiveSuggestion();

                while (
                    leaf.parentElement &&
                    !isSlateElement(leaf.parentElement) &&
                    !isSlateEditor(leaf.parentElement)
                ) {
                    if (leaf.classList.contains(`slate-${type}`)) {
                        const suggestionEntry = api.suggestion!.node({
                            isText: true,
                        });

                        if (!suggestionEntry) {
                            unsetActiveSuggestion();

                            break;
                        }

                        const id = api.suggestion!.nodeId(suggestionEntry[0]);

                        setOption('activeId', id ?? null);
                        isSet = true;

                        break;
                    }

                    leaf = leaf.parentElement;
                }

                if (!isSet) unsetActiveSuggestion();
            },
        },
        options: {
            activeId: null,
            currentUserId: '',
            hoverId: null,
            uniquePathMap: new Map(),
        },
        render: {
            belowNodes: SuggestionBelowNodes as any,
            node: SuggestionLeaf,
        },
    }
);
